import React, { useEffect }  from 'react'
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
//import { deepOrange } from '@material-ui/core/colors';
import { MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBView, MDBContainer } from"mdbreact";
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
//import default_banners from "../bob_banners.json";
import axios from 'axios';
//import { GenericResponse } from '../models/Conversation';

import Slide from '@material-ui/core/Slide';
//import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
//import Toolbar from '@material-ui/core/Toolbar';
import PropTypes from 'prop-types';

const URL:string = "https://api.us-south.assistant.watson.cloud.ibm.com/v1/workspaces/f038a7e7-ab28-440a-9a72-053465104446/message?version=2020-04-01"

const API_KEY = process.env.REACT_APP_API_KEY!;
const API_USERNAME = process.env.REACT_APP_USERNAME!;

let carousalItem: { id: number, img: string, link: string }[] = [];
let showCarousal:boolean = false;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        //backgroundColor: deepOrange[500],
        margin: 0,
        padding: 0,
        flexGrow: 1,
        height: "100%",
        //marginTop:"100px"
    },
    title: {   
        margin: 0,
        paddingLeft: 10,
        paddingRight: 10,
        flexGrow: 1,        
        color:"#fff",
        //color: theme.palette.getContrastText(deepOrange[500])
        //color: "rgb(0, 75, 145)",
        //color: "#162b75",
        fontFamily: "Roboto,Helvetica,Arial,sans-serif",
        //fontWeight: 100,
        //fontSize:"1.2em",
        lineHeight:"1.46em"
      },
    spacer: {
        marginTop: '15px'
        //background: "linear-gradient(to bottom, #ff5722, #ff8a65, #ffab91, #ffccbc, #fbe9e7, #fafafa)",
    },
    carouselContainer: {
        height: "70%",
        width: "75%",
        maxWidth: "400px",
        padding: 0,
    },
    carouselView: {
        height: "100%",
    },
    hidediv:{
        height:"110px",
        backgroundColor: "#ff5722",
       // position: "fixed",
        width:"100%",
        //top:"0",
        //display:"block"
      }
}));

function HideOnScroll(props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({ target: window ? window() : undefined });
  
    return (
      <Slide appear={false} direction="down" in={!trigger}>
        {children}
      </Slide>
    );
  }
  
  HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
  };

const IntroCarousel = (props:any) => {
    const classes = useStyles();
    let greeting = "";
    let d = new Date(),
    time = d.getHours();
        
    if (time < 12) {
      greeting = "Good Morning!";
    }
    
    if (time >= 12 && time < 16) {
      greeting = "Good Afternoon!";
    }

    if (time >= 16) {
      greeting = "Good Evening!";
    }
    

      function GetCarousalData(){
        useEffect(() => {
          //alert(typeof API_KEY);
        axios.post(
          URL,
          {
            input: {
              text: "Hello"
            }
          },
          {
            headers: {'Content-Type':'application/json'},
            auth: {username:API_USERNAME,password: API_KEY }
          }
        ).then(function (response) {
          carousalItem = response.data.context.displayCarousel;
          showCarousal = (response.data.context.showCarousal === "true");
        })
        // console.log(showCarousal);
        // console.log(typeof showCarousal);
        }, []);
        
      }

    useScrollPosition(({ prevPos, currPos }:any) => {
        props.scrollCallback(prevPos.y, currPos.y);
      });
    
    return (
        <Box className={classes.root}>
            <HideOnScroll {...props}>
                <div className = {classes.hidediv}>
                      <Typography variant="caption" display="block" gutterBottom align="justify" className={classes.title}>
                        {/* <Div marginTop={0}  paddingLeft={1} paddingRight={1}  paddingBottom={0}  m={1}> */}
                        <h5 style={{color:"#fff", fontSize:"20px", fontWeight:500}}>{greeting}</h5>
                            Welcome  to Bank of Baroda, this is ADI, your virtual assistant.
                            If you need help simply type your question or choose from the options provided below.
                            
                        {/* </Div> */}
                    </Typography>
                    {/* <Typography variant="body1" className={classes.title} align="justify">
                        <Box marginTop={0}  paddingLeft={1} paddingRight={1} paddingTop={0} paddingBottom={1} fontWeight="fontWeightMedium" m={1}>
                            Please don't enter confidential data in this chat.
                        </Box>
                    </Typography> */}
                </div>
            </HideOnScroll>
              <Box className={classes.spacer}>
                <MDBContainer className={classes.carouselContainer}>
                    { (() => {
                        GetCarousalData();
                        if(showCarousal){
                            return (                             
                              <MDBCarousel
                                  activeItem={1}
                                  length={carousalItem.length}
                                  showControls={true}
                                  showIndicators={false}
                                  slide={true}
                                  className="z-depth-1"
                              >
                                  
                                  <MDBCarouselInner style={{height:"200px"}}>
                                      {carousalItem.map(function(element){
                                          //alert(JSON.stringify(banner));
                                          return <MDBCarouselItem itemId={element.id}>
                                                      <MDBView className = {classes.carouselView}>
                                                          <a href={element.link} target="_blank" rel="noreferrer">
                                                              <img  style={{height:"200px"}}
                                                                  className="d-block w-100"
                                                                  src={element.img}
                                                                  alt="Slide"
                                                              />
                                                          </a>
                                                      </MDBView>
                                                  </MDBCarouselItem>
                                      })}
                                  
                                  </MDBCarouselInner>
                              </MDBCarousel>
                           
                            );
                          }
                        })()
                    }
                </MDBContainer>
            </Box>
        </Box> 
    )
    
};

export default IntroCarousel;

